export function TableRowStatus(props: any) {
  if (props.tooltip) {
    return (
      <td
        className={
          props.statusColor +
          "p-2 border border-deeppurple truncate group-hover:bg-gray-200 has-tooltip"
        }
      >
        <span className="tooltip rounded shadow-lg p-2 bg-white text-ghPurple">
          {props.value ? props.value : "unknown"}
        </span>
        {props.value ? props.value : "unknown"}
      </td>
    );
  }
  return (
    <td
      className={
        props.statusColor +
        "p-2 border border-deeppurple truncate group-hover:bg-gray-200"
      }
    >
      {props.value ? props.value : "unknown"}
    </td>
  );
}

export function TableRow(props: any) {
  if (props.tooltip) {
    return (
      <td className="p-2 border border-deeppurple truncate group-hover:bg-gray-200 has-tooltip">
        <span className="tooltip rounded shadow-lg p-2 bg-white border-2 text-ghPurple">
          {props.value}
        </span>
        {props.value}
      </td>
    );
  }
  return (
    <td className="p-2 border border-deeppurple truncate group-hover:bg-gray-200">
      {props.value}
    </td>
  );
}
